/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import './AccordionPane.scss';
import {
  Heading,
  Icon,
  Collapsible,
} from 'components/common';

class AccordionPane extends React.Component {
  constructor(props) {
    super(props);
    const { isExpanded } = props;

    this.state = {
      isExpanded,
    };

    this.toggleAccordionPane = this.toggleAccordionPane.bind(this);
  }

  async toggleAccordionPane() {
    const { isExpanded } = this.state;

    this.setState({
      isExpanded: !isExpanded,
    });
  }

  render() {
    const { isExpanded } = this.state;
    const {
      title,
      children,
      dataSelectorId,
      onClick,
    } = this.props;

    return (
      <div className="accordion-pane" data-selector={dataSelectorId} data-selector-type="accordion-pane">
        <div
          className="accordion-pane-header"
          onClick={() => {
            this.toggleAccordionPane();
            if (onClick) {
              onClick();
            }
          }}
          data-selector-type="header"
        >
          <div className="title">
            <Heading as="h3">
              {title}
            </Heading>
          </div>
          <div className="right-icon">
            <Icon secondary name={isExpanded ? 'chevron_up' : 'chevron_down'} />
          </div>
        </div>
        <Collapsible isCollapsed={!isExpanded}>
          <div className="accordion-pane-content" data-selector-type="accordion-pane-content">
            {children}
          </div>
        </Collapsible>
        <hr className="divider" />
      </div>
    );
  }
}

AccordionPane.defaultProps = {
  isExpanded: false,
  children: null,
  title: '',
  dataSelectorId: null,
  onClick: null,
};

AccordionPane.propTypes = {
  isExpanded: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.node,
  dataSelectorId: PropTypes.string,
  onClick: PropTypes.func,
};

export default AccordionPane;
